import { Loader2, ArrowRight } from "lucide-react";
import { MicButton } from "@/components/MicButton";
import { GratitudeChips } from "@/components/GratitudeChips";
import { GRATITUDE_ASKS } from "@/lib/gratitude";

const PRESETS = {
  kid: ["tell me a story about a dragon", "explain why the sky is blue", "help me with my spelling words"],
};

export const DirectiveInput = ({ age, text, setText, onSubmit, loading }) => (
  <section className="pp-card" data-testid="directive-section">
    <p className="pp-label">Step 1 · Your directive</p>
    <h1 className="pp-h1" data-testid="home-title">How can I help?</h1>
    <p className="pp-sub">
      Speak or type it. Don't forget your <b>magic word</b>!
    </p>
    <textarea
      data-testid="directive-input-textarea"
      className="pp-textarea"
      rows={3}
      value={text}
      onChange={(e) => setText(e.target.value)}
      placeholder="Let's practice…"
    />
    <div className="pp-presets">
      {PRESETS[age].map((p, i) => (
        <button key={p} data-testid={`preset-prompt-pill-${i}`} className="pp-pill" onClick={() => setText(p)}>
          {p}
        </button>
      ))}
    </div>
    <GratitudeChips
      label="Earn a golden acorn with gratitude words"
      phrases={GRATITUDE_ASKS[age]}
      testPrefix="gratitude-ask"
    />
    <div className="pp-actions">
      <MicButton testId="voice-record-mic-button" onText={(t) => setText(t)} label="Speak it" />
      <button
        data-testid="submit-directive-button"
        className="pp-primary"
        disabled={!text.trim() || loading}
        onClick={onSubmit}
      >
        {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <>Check my manners <ArrowRight className="h-5 w-5" /></>}
      </button>
    </div>
  </section>
);
